import { ArrowPathIcon } from '@heroicons/react/24/outline'
import { PencilIcon } from '@heroicons/react/24/solid'
import React, { useCallback, useState } from 'react'
import { useEffect } from 'react'
import toast from 'react-hot-toast'
import { useDispatch, useSelector } from 'react-redux'
import { Fade } from 'react-reveal'
import { useHistory } from 'react-router-dom'
import { ConfirmAction } from '../../../components/ConfirmAction'
import DashedButton from '../../../components/elements/Buttons/DashedButton'
import DefaultBtn from '../../../components/elements/Buttons/DefaultBtn'
import { DeleteIcon } from '../../../components/elements/forms/FormDomain'
import SearchInput from '../../../components/elements/Inputs/SearchInput'
import { Loader } from '../../../components/Spinner'
import ToastAction from '../../../components/ToastAction'
import { deleteUser, fetchUsers, getUsers } from '../../../features/users/manageUsersSlice'
import { selectUserInfo } from '../../../features/users/userInfoSlice'
import { useSubscriptionGard } from '../../../guards/subscription/useSubscriptionGard'
import { classNames, ToradorFilterDom } from '../../../utils'
import ClinOeuil from '../../../images/4X4clin.jpg'
import { selectorTour } from '../../../features/tour/tourSlice'

function Users() {
  const [resultSearch, setResultSearch] = useState([])
  const dispatch = useDispatch();
  const history = useHistory()
  const userInfoContext = useSelector(selectUserInfo);
  const loadingUsers = useSelector(state => state.users.loading)
  const usersCompany = useSelector(getUsers)
  const isTourLaunched = useSelector(selectorTour)

  const { users } = useSubscriptionGard()


  const _inviteUser = useCallback(() => {
    if (!users.canAdd) {
      const label = users.limit
        ? `Votre forfait actuel ne vous permet pas d'inviter plus de 0${users.limit} utilisateurs.`
        : "Vous n'avez pas encore souscrit à un forfait."
      const description = users.limit ? "Voulez-vous changer de forfait ?" : "Voulez-vous souscrire maintenant ?"

      toast.custom((t) => <ToastAction toastRef={t} label={label} description={description} okAction={() => history.push('/account/forfait')}>
        <img src={ClinOeuil} className="h-14 w-12" />
      </ToastAction>
      )
      return
    }
    history.push('/account/users/add')
  }, [users.canAdd])

  useEffect(() => {
    dispatch(fetchUsers({ company_id: userInfoContext?.user?.company_id }))
  }, [userInfoContext?.user?.company_id])

  const _refreshuser = useCallback(() => {
    dispatch(fetchUsers({ company_id: userInfoContext?.user?.company_id }))
  }, [userInfoContext?.user?.company_id])

  const _searchUser = useCallback(e => {
    const resultSearch = ToradorFilterDom(e.target.value, usersCompany)
    setResultSearch(resultSearch)
  }, [usersCompany])

  return (
    <div className="pt-10">
      <div className="w-full mx-auto max-w-lg lg:max-w-md">
        <SearchInput onChange={_searchUser} id='search_users' name='search_users' placeholder='Rechercher les utilisateurs...' />
      </div>

      <div className='w-full mx-auto xl:max-w-7xl space-y-2 mt-10'>
        <div className="flex items-center justify-end">
          <DefaultBtn Icon={ArrowPathIcon} label={loadingUsers ? 'Actualisation...' : 'Actualiser'} classIcon={loadingUsers ? 'animate-spin' : ''} disabled={loadingUsers} onClick={_refreshuser} />
        </div>
        <table className='w-full text-sm text-left text-gray-500 shadow rounded-lg overflow-hidden'>
          <thead className='text-xs text-white uppercase bg-general-teal'>
            <tr>
              <th className="py-3 px-3 w-[300px]">
                <div className="flex items-center space-x-2">
                  <span>Noms et prénoms</span>
                  <button type='button'><svg xmlns="http://www.w3.org/2000/svg" className="ml-1 w-3 h-3" aria-hidden="true" fill="currentColor" viewBox="0 0 320 512"><path d="M27.66 224h264.7c24.6 0 36.89-29.78 19.54-47.12l-132.3-136.8c-5.406-5.406-12.47-8.107-19.53-8.107c-7.055 0-14.09 2.701-19.45 8.107L8.119 176.9C-9.229 194.2 3.055 224 27.66 224zM292.3 288H27.66c-24.6 0-36.89 29.77-19.54 47.12l132.5 136.8C145.9 477.3 152.1 480 160 480c7.053 0 14.12-2.703 19.53-8.109l132.3-136.8C329.2 317.8 316.9 288 292.3 288z" /></svg></button>
                </div>
              </th>
              <th rowSpan={1} className="py-3 px-6 w-[300px]">Statut</th>
              <th rowSpan={1} className="py-3 px-6 w-[500px]">Email</th>
              <th className="py-3 px-2"></th>
            </tr>
          </thead>
          <tbody className="bg-white overflow-hidden shadow">
            {resultSearch.length > 0 && resultSearch.map(user => <Trow key={user.id} user={user} currentUser={userInfoContext?.user} />)}
            {resultSearch.length <= 0 && usersCompany.length > 0 && usersCompany.map(user => <Trow key={user.id} user={user} currentUser={userInfoContext?.user} />)}
          </tbody>
        </table>
        {loadingUsers && usersCompany.length <= 0 && <Loader />}
        <DashedButton disabled={isTourLaunched} id="invite-step" label="Inviter un utilisateur" onClick={_inviteUser} />
        {isTourLaunched && <input type='button' id="invite-step-action" onClick={_inviteUser} className="hidden" />}
      </div>
    </div>
  )
}

export default Users

const Trow = ({ user, currentUser }) => {
  const [openPreventRemove, setOpenPreventRemove] = useState(false)
  const loadingUsers = useSelector(state => state.users.loading)
  const isTourLaunched = useSelector(selectorTour)
  const dispatch = useDispatch();
  const history = useHistory()

  const _preventRemove = useCallback((e) => {
    e.stopPropagation()
    if (user.id === currentUser?.sub || !currentUser?.admin) return
    setOpenPreventRemove(true)
  }, [user, currentUser])

  const _removeUser = useCallback((e) => {
    e.stopPropagation()
    if (user.id === currentUser?.sub || !currentUser?.admin) return
    dispatch(deleteUser({ company_id: currentUser?.company_id, requested_user_id: user.id }))
    _closeConfirmDialog()
  }, [user, currentUser])

  const _editUser = () => {
    history.push(`/account/users/edit/${user.id}`, { user })
  }

  const _closeConfirmDialog = useCallback(() => {
    setOpenPreventRemove(false)
  }, [])

  const isCurrentUser = user.id === currentUser?.sub
  const hightlightOwner = user.owner ? 'text-general-teal' : 'text-gray-500'

  return <>
    <ConfirmAction open={openPreventRemove} title="Suppression d'utilisateur" question="Êtes-vous sûr de vouloir supprimer ce compte" description="Sachez que cette action est irreversible." onSuccess={_removeUser} onFailure={_closeConfirmDialog} />
    <Fade bottom>
      <tr className="bg-white border-b hover:bg-teal-50 transition-colors group">
        <td className={`py-4 px-6 font-medium whitespace-nowrap ${hightlightOwner}`}>
          {user.name} {isCurrentUser && <div className="badge badge-sm">Vous</div>} {user.owner && <div className="badge badge-sm bg-general-teal border-general-teal">Owner</div>}
        </td>
        <td className={`py-4 px-6 font-medium whitespace-nowrap ${hightlightOwner}`}>{user.admin ? 'Admin' : 'Utilisateur'}</td>
        <td className={`py-4 px-6 font-medium whitespace-nowrap ${hightlightOwner}`}>{user.email}</td>
        <td className={`py-4 px-6 font-medium whitespace-nowrap ${hightlightOwner}`}>
          <div className={classNames("hidden", isCurrentUser || user.owner ? '' : 'group-hover:flex items-center space-x-7')}>
            <div className="tooltip" data-tip="Editer">
              <button onClick={_editUser} disabled={isTourLaunched || isCurrentUser || !currentUser?.admin || user.owner || loadingUsers} type='button'><PencilIcon className="h-3" /></button>
            </div>
            <div className="tooltip" data-tip="Supprimer">
              <button onClick={_preventRemove} disabled={isTourLaunched || isCurrentUser || !currentUser?.admin || user.owner || loadingUsers} type='button'><DeleteIcon className="h-3 hover:text-pink-500" /></button>
            </div>
          </div>
        </td>
      </tr>
    </Fade>
  </>
}